// Types of action for requesting player leaderboard
export const REQUEST_PLAYER_LEADERBOARD = 'REQUEST_PLAYER_LEADERBOARD';
export const REQUEST_PLAYER_LEADERBOARD_PENDING = 'REQUEST_PLAYER_LEADERBOARD_PENDING';
export const REQUEST_PLAYER_LEADERBOARD_SUCCESS = 'REQUEST_PLAYER_LEADERBOARD_SUCCESS';
export const REQUEST_PLAYER_LEADERBOARD_ERROR = 'REQUEST_PLAYER_LEADERBOARD_ERROR';
// Types of action for requesting player leaderboard as csv
export const REQUEST_PLAYER_LEADERBOARD_AS_CSV = 'REQUEST_PLAYER_LEADERBOARD_AS_CSV';